"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.styles = void 0;
var styles_1 = require("@material-ui/core/styles");
var styles_2 = require("../../styles");
var palettes_1 = require("../../styles/palettes");
var styles = function (_a) {
    var spacing = _a.spacing;
    return styles_1.createStyles({
        container: __assign({ paddingRight: spacing(6), height: '100%', overflowY: 'auto' }, styles_2.withCustomVerticalScrollbar()),
        listItem: {
            display: 'flex',
            alignItems: 'center',
            width: '100%',
            padding: 0,
            margin: spacing(4, 0),
            position: 'relative',
            zIndex: 1400,
        },
        logo: {
            width: 50,
            height: 50,
            padding: spacing(1),
            margin: spacing(0, 3, 0),
        },
        logoImage: {
            width: '100%',
            height: '100%',
            objectFit: 'contain',
        },
        dragHandleButton: {
            display: 'flex',
        },
        dragHandle: {
            width: 24,
            height: 24,
        },
        divider: {
            margin: spacing(0, 2),
            height: 50,
            width: 1,
            backgroundColor: palettes_1.dark[50],
        },
        removeButton: {
            display: 'flex',
        },
        removeIcon: {
            fill: palettes_1.danger[500],
        },
        textWrapper: {
            flex: 1,
        },
        trash: {
            fill: palettes_1.danger[500],
            width: 24,
            height: 24,
        },
        sliderValueContainer: {
            display: 'flex',
            alignItems: 'center',
            marginTop: spacing(1),
        },
        sliderValue: {
            marginRight: spacing(2),
            width: spacing(5),
            marginBottom: 0,
        },
        slider: {
            flex: 1,
            zIndex: 1,
        },
        popper: {
            zIndex: 130200,
        },
        bolden: {
            fontWeight: 500,
        },
        sortableHelper: {
            zIndex: '1301 !important',
        },
    });
};
exports.styles = styles;
